import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

function AccordionSection({ sectionKey, title, openSections, onToggle, children }) {
  return (
    <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
      <button
        type="button"
        className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
        onClick={() => onToggle(sectionKey)}
        aria-expanded={openSections[sectionKey]}
      >
        <h2>{title}</h2>
        <span
          className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections[sectionKey] ? 'open' : ''}`}
          aria-hidden
        />
      </button>

      {openSections[sectionKey] && (
        <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
          {children}
        </div>
      )}
    </section>
  );
}

export default function ProfileGalleryHelpSuarteFeaturesPage() {
  const t = useTranslations('galleries_help.suarte_features');
  const [openSections, setOpenSections] = useState({
    board: false,
    thoughts: false,
    ratings: false,
    suarteworld: false,
    community: false,
    storyTold: false,
    likes: false,
    inspiring: false,
    dataInsights: false,
    digitalCertificate: false,
    members: false,
    exhibitions: false,
    otherProducts: false,
    offers: false,
    invoices: false,
    galleryAiProfile: false,
    artistAiProfile: false,
    artworkAi: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <AccordionSection
          sectionKey="board"
          title={t('sections.board.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.board.p1')}</p>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.board.posts.title')}</h3>
            <p>{t('sections.board.posts.p1')}</p>
            <ul>
              <li>{t('sections.board.posts.list_1')}</li>
              <li>{t('sections.board.posts.list_2')}</li>
              <li>{t('sections.board.posts.list_3')}</li>
              <li>{t('sections.board.posts.list_4')}</li>
            </ul>
            <p>{t('sections.board.posts.p2')}</p>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.board.articles.title')}</h3>
            <p>{t('sections.board.articles.p1')}</p>
            <ul>
              <li>{t('sections.board.articles.list_1')}</li>
              <li>{t('sections.board.articles.list_2')}</li>
              <li>{t('sections.board.articles.list_3')}</li>
              <li>{t('sections.board.articles.list_4')}</li>
            </ul>
            <p>{t('sections.board.articles.p2')}</p>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.board.recommended.title')}</h3>
            <p>{t('sections.board.recommended.p1')}</p>
            <p>{t('sections.board.recommended.p2')}</p>
            <ul>
              <li>{t('sections.board.recommended.list_1')}</li>
              <li>{t('sections.board.recommended.list_2')}</li>
              <li>{t('sections.board.recommended.list_3')}</li>
            </ul>
            <p>{t('sections.board.recommended.p3')}</p>
          </div>
        </AccordionSection>

        <AccordionSection
          sectionKey="digitalCertificate"
          title={t('sections.digital_certificate.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.digital_certificate.p1')}</p>
          <p>{t('sections.digital_certificate.p2')}</p>
          <p>{t('sections.digital_certificate.p3')}</p>
          <p>{t('sections.digital_certificate.p4')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="invoices"
          title={t('sections.invoices.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.invoices.intro')}</p>
          <ul>
            <li>
              <strong>{t('sections.invoices.add_invoices_label')}</strong> {t('sections.invoices.add_invoices_body')}
            </li>
            <li>
              <strong>{t('sections.invoices.suarte_invoices_label')}</strong> {t('sections.invoices.suarte_invoices_body')}
            </li>
          </ul>
        </AccordionSection>

        <AccordionSection
          sectionKey="thoughts"
          title={t('sections.thoughts.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.thoughts.p1')}</p>
          <p>{t('sections.thoughts.p2')}</p>
          <p>{t('sections.thoughts.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="ratings"
          title={t('sections.ratings.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.ratings.p1')}</p>
          <p>{t('sections.ratings.p2')}</p>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.ratings.prompts_title')}</h3>
            <ul>
              <li>{t('sections.ratings.prompt_1')}</li>
              <li>{t('sections.ratings.prompt_2')}</li>
              <li>{t('sections.ratings.prompt_3')}</li>
            </ul>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.ratings.why_title')}</h3>
            <p>{t('sections.ratings.why_p1')}</p>
          </div>
        </AccordionSection>

        <AccordionSection
          sectionKey="suarteworld"
          title={t('sections.suarteworld.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.suarteworld.p1')}</p>
          <p>{t('sections.suarteworld.p2')}</p>
          <p>{t('sections.suarteworld.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="community"
          title={t('sections.community.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.community.p1')}</p>
          <p>{t('sections.community.p2')}</p>
          <p>{t('sections.community.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="storyTold"
          title={t('sections.story_told.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.story_told.p1')}</p>
          <p>{t('sections.story_told.p2')}</p>
          <p>{t('sections.story_told.p3')}</p>
          <p>{t('sections.story_told.p4')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="likes"
          title={t('sections.likes.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.likes.intro')}</p>
          <ul>
            <li>{t('sections.likes.list_1')}</li>
            <li>{t('sections.likes.list_2')}</li>
            <li>{t('sections.likes.list_3')}</li>
            <li>{t('sections.likes.list_4')}</li>
            <li>{t('sections.likes.list_5')}</li>
          </ul>
          <p>{t('sections.likes.p1')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="inspiring"
          title={t('sections.inspiring.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.inspiring.p1')}</p>
          <p>{t('sections.inspiring.p2')}</p>
          <p>{t('sections.inspiring.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="dataInsights"
          title={t('sections.data_insights.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.data_insights.p1')}</p>
          <p>{t('sections.data_insights.p2')}</p>
          <ul>
            <li>{t('sections.data_insights.list_1')}</li>
            <li>{t('sections.data_insights.list_2')}</li>
            <li>{t('sections.data_insights.list_3')}</li>
            <li>{t('sections.data_insights.list_4')}</li>
            <li>{t('sections.data_insights.list_5')}</li>
            <li>{t('sections.data_insights.list_6')}</li>
            <li>{t('sections.data_insights.list_7')}</li>
            <li>{t('sections.data_insights.list_8')}</li>
            <li>{t('sections.data_insights.list_9')}</li>
          </ul>
          <p>{t('sections.data_insights.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="members"
          title={t('sections.members.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.members.p1')}</p>
          <ul>
            <li>{t('sections.members.list_1')}</li>
            <li>{t('sections.members.list_2')}</li>
            <li>{t('sections.members.list_3')}</li>
            <li>{t('sections.members.list_4')}</li>
            <li>{t('sections.members.list_5')}</li>
          </ul>
          <p>{t('sections.members.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="exhibitions"
          title={t('sections.exhibitions.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.exhibitions.p1')}</p>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.exhibitions.create.title')}</h3>
            <p>{t('sections.exhibitions.create.intro')}</p>
            <ul>
              <li>{t('sections.exhibitions.create.list_1')}</li>
              <li>{t('sections.exhibitions.create.list_2')}</li>
              <li>{t('sections.exhibitions.create.list_3')}</li>
              <li>{t('sections.exhibitions.create.list_4')}</li>
            </ul>
            <p>{t('sections.exhibitions.create.p1')}</p>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.exhibitions.manage.title')}</h3>
            <ul>
              <li>{t('sections.exhibitions.manage.list_1')}</li>
              <li>{t('sections.exhibitions.manage.list_2')}</li>
              <li>{t('sections.exhibitions.manage.list_3')}</li>
            </ul>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.exhibitions.good_to_know.title')}</h3>
            <ul>
              <li>{t('sections.exhibitions.good_to_know.list_1')}</li>
              <li>{t('sections.exhibitions.good_to_know.list_2')}</li>
              <li>{t('sections.exhibitions.good_to_know.list_3')}</li>
            </ul>
            <p>{t('sections.exhibitions.good_to_know.p1')}</p>
          </div>
        </AccordionSection>

        <AccordionSection
          sectionKey="otherProducts"
          title={t('sections.other_products.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.other_products.p1')}</p>
          <p>{t('sections.other_products.p2')}</p>
          <p>{t('sections.other_products.intro')}</p>
          <ul>
            <li>{t('sections.other_products.list_1')}</li>
            <li>{t('sections.other_products.list_2')}</li>
            <li>{t('sections.other_products.list_3')}</li>
            <li>{t('sections.other_products.list_4')}</li>
          </ul>
        </AccordionSection>

        <AccordionSection
          sectionKey="offers"
          title={t('sections.offers.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.offers.p1')}</p>
          <p>{t('sections.offers.intro')}</p>
          <ul>
            <li>{t('sections.offers.list_1')}</li>
            <li>{t('sections.offers.list_2')}</li>
            <li>{t('sections.offers.list_3')}</li>
            <li>{t('sections.offers.list_4')}</li>
            <li>{t('sections.offers.list_5')}</li>
            <li>{t('sections.offers.list_6')}</li>
            <li>{t('sections.offers.list_7')}</li>
            <li>{t('sections.offers.list_8')}</li>
          </ul>

          <div className="artist-help-category__note">
            <h3>{t('sections.offers.note_title')}</h3>
            <p>{t('sections.offers.note_p1')}</p>
          </div>

          <div className="artist-help-category__stack gallery-help-category__stack">
            <h3>{t('sections.offers.coming_title')}</h3>
            <p>{t('sections.offers.coming_p1')}</p>
          </div>
        </AccordionSection>

        <AccordionSection
          sectionKey="galleryAiProfile"
          title={t('sections.gallery_ai_profile.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.gallery_ai_profile.p1')}</p>
          <p>{t('sections.gallery_ai_profile.intro')}</p>
          <ul>
            <li>{t('sections.gallery_ai_profile.list_1')}</li>
            <li>{t('sections.gallery_ai_profile.list_2')}</li>
            <li>{t('sections.gallery_ai_profile.list_3')}</li>
            <li>{t('sections.gallery_ai_profile.list_4')}</li>
            <li>{t('sections.gallery_ai_profile.list_5')}</li>
          </ul>
          <p>{t('sections.gallery_ai_profile.p2')}</p>
          <p>{t('sections.gallery_ai_profile.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="artistAiProfile"
          title={t('sections.artist_ai_profile.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.artist_ai_profile.p1')}</p>
          <p>{t('sections.artist_ai_profile.intro')}</p>
          <ul>
            <li>{t('sections.artist_ai_profile.list_1')}</li>
            <li>{t('sections.artist_ai_profile.list_2')}</li>
            <li>{t('sections.artist_ai_profile.list_3')}</li>
            <li>{t('sections.artist_ai_profile.list_4')}</li>
          </ul>
          <p>{t('sections.artist_ai_profile.p2')}</p>
          <p>{t('sections.artist_ai_profile.p3')}</p>
          <p>{t('sections.artist_ai_profile.p4')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="artworkAi"
          title={t('sections.artwork_ai.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.artwork_ai.p1')}</p>
          <p>{t('sections.artwork_ai.intro')}</p>
          <ul>
            <li>{t('sections.artwork_ai.list_1')}</li>
            <li>{t('sections.artwork_ai.list_2')}</li>
          </ul>
          <p>{t('sections.artwork_ai.p2')}</p>
          <p>{t('sections.artwork_ai.p3')}</p>
        </AccordionSection>
      </div>
    </section>
  );
}
